import * as React from 'react'

import * as styles from './Confetti.css'
import Kamikire from './Kamikire'

const DEF_KAMIKIRE_MAX: number = 30

class Confetti extends React.PureComponent {
  public stageHeight = 0

  private kamikireList: Kamikire[] = []
  private cvs: any
  private ctx: any
  private stageWidth = 0
  private resizeFlg = true

  constructor(props: any) {
    super(props)
    this.cvs = React.createRef()
  }

  public componentDidMount() {
    if (!this.cvs.current) {
      return
    }
    this.stageWidth = window.innerWidth
    this.stageHeight = window.innerHeight

    this.cvs.current.width = this.stageWidth
    this.cvs.current.height = this.stageHeight

    this.ctx = this.cvs.current.getContext('2d')
    this.ctx.fillStyle = '#FFF'
    this.ctx.fillRect(0, 0, this.cvs.current.width, this.cvs.current.height)

    // tslint:disable-next-line:no-increment-decrement
    for (let i = 0; i < DEF_KAMIKIRE_MAX; i++) {
      const kami = new Kamikire(5 + Math.floor(Math.random() * 5), this.ctx)

      kami.x = Math.random() * this.stageWidth
      kami.y = Math.random() * this.stageHeight

      this.ctx.fillStyle = `#${kami.r}${kami.g}${kami.b}`
      this.ctx.fillRect(kami.x, kami.y, kami.size, kami.size)

      this.kamikireList.push(kami)
    }

    setInterval(() => this.enterFrame(), 30)
  }

  public enterFrame() {
    if (!this.cvs.current) {
      return
    }
    // 初期化
    if (this.resizeFlg) {
      this.resizeFlg = false
      this.cvs.current.width = this.stageWidth
      this.cvs.current.height = this.stageHeight
    }
    this.ctx.clearRect(0, 0, this.stageWidth, this.stageHeight)

    // 表示更新
    // tslint:disable-next-line:no-increment-decrement
    for (let i = 0; i < DEF_KAMIKIRE_MAX; i++) {
      if (this.kamikireList[i].y > 0) {
        let par = this.kamikireList[i].y / this.stageHeight
        par = 1 - par

        this.kamikireList[i].alpha = par
      }

      if (this.kamikireList[i].x - this.kamikireList[i].size / Math.SQRT2 > this.stageWidth) {
        this.kamikireList[i].x -= this.stageWidth
      }
      if (this.kamikireList[i].x + this.kamikireList[i].size / Math.SQRT2 < 0) {
        this.kamikireList[i].x += this.stageWidth
      }
      if (this.kamikireList[i].y - this.kamikireList[i].size / Math.SQRT2 > this.stageHeight) {
        this.kamikireList[i].y -= this.stageHeight
      }

      this.kamikireList[i].fall()
    }
  }

  public render() {
    return <canvas ref={this.cvs} className={styles.canvas} />
  }
}

export default Confetti
